<template>
  <div class="entry">
    <span v-if="!personalStore.isAuthorized" class="entry__link" @click="handlerOpenModal">
      <svg class="entry__user">
        <use xlink:href="#svg-user"></use>
      </svg>
    </span>
    <a v-else :href="url" class="entry__link">
      <svg class="entry__user">
        <use xlink:href="#svg-user"></use>
      </svg>
      <span class="entry-circle">
        <svg class="entry-circle__icon">
          <use xlink:href="#svg-check"></use>
        </svg>
      </span>
    </a>
  </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent, computed } from 'vue';
import useModal from '@use/useModal/useModal';
import { usePersonalStore } from '@/storePinia/stores/personal';

const modal = useModal();
const personalStore = usePersonalStore();

const url = computed(() => personalStore.authInfo.url);

const SignIn = defineAsyncComponent(() => import('@components/Cabinet/Entry/SignIn/SignIn.vue'));

const handlerOpenModal = () => {
  modal.show(
    SignIn,
    {},
    {
      width: '900px',
      backgroundClose: false,
    }
  );
};
</script>
<style lang="scss" scoped>
.entry {
  display: inline-flex;
  position: relative;
  &__link {
    display: inline-flex;
    align-items: center;
    color: var(--text-colour-primary);
    cursor: pointer;
    &:hover {
      .entry__user {
        fill: var(--color-link-hover-dark);
        transform: scale(1.1);
      }
    }
  }
  &__user {
    width: 24px;
    height: 24px;
    fill: #030304;
    transition: 0.2s linear fill, 0.2s linear transform;
  }
}
.entry-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  background-color: #448757;
  position: absolute;
  top: -8px;
  right: -8px;
  &__icon {
    fill: #fff;
    width: 12px;
    height: 12px;
  }
}
</style>
